import { Button, makeStyles } from '@material-ui/core';
import { useSnackbar as useSnackbarN } from 'notistack';
import React, { useCallback } from 'react';

const useSnackbarStyles = makeStyles(theme => ({
  buttonsContainer: {
    '& span': {
      textTransform: 'uppercase',
    },

    '& button': {
      color: theme.palette.white.main,
    },
  },
}));

const useSnackbar = () => {
  const classes = useSnackbarStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbarN();

  const properEnqueueSnackbar = useCallback(
    (text, { buttons, action, ...props } = {}) => enqueueSnackbar(text, {
      ...props,
      action: snackbarId => (
        <div className={classes.buttonsContainer}>
          {buttons
              && buttons.map(btnProps => (
                <Button
                  onClick={() => {
                    closeSnackbar(snackbarId);
                    btnProps.onClick();
                  }}
                  key={btnProps.text}
                >
                  {btnProps.text}
                </Button>
              ))}
          {action && action(snackbarId)}
          <Button onClick={() => closeSnackbar(snackbarId)}>Close</Button>
        </div>
      ),
    }),
    [enqueueSnackbar]
  );

  const enqueueErrorSnackbar = useCallback(
    (text, props) => properEnqueueSnackbar(text, { ...props, variant: 'error' }),
    [properEnqueueSnackbar]
  );

  const enqueueSuccessSnackbar = useCallback(
    (text, props) => properEnqueueSnackbar(text, { ...props, variant: 'success' }),
    [properEnqueueSnackbar]
  );

  return {
    closeSnackbar,
    enqueueErrorSnackbar,
    enqueueSnackbar: properEnqueueSnackbar,
    enqueueSuccessSnackbar,
  };
};

export default useSnackbar;
